///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.short_dated = abcsetup.short_dated || {};
abcsetup.short_dated.opportunities = abcsetup.short_dated.opportunities || {};
abcsetup.short_dated.opportunities.show = abcsetup.short_dated.opportunities.show || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////

abcsetup.short_dated.opportunities.show = {
    /**
     *
     */
    // init: function () {
    //     $(document).on('click', "#new_short_dated_item", function () {
    //         $('#new-short-dated-item-modal').modal('show');
    //     });
    // },

    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function () {
        // Bind any fields events
        abcsetup.short_dated_opportunity.common.bindFields();
    },
}
